import { newId } from "helpers";

const addNewTemplate = (templateType, options = {}, activeApp) => {
  if (!templateType) throw new Error("template type not passed");

  let navComponent;

  // console.log("adding new template..." + templateType);
  // console.dir(activeApp);

  const newTemplate = appCatalog[templateType](activeApp);

  // console.dir(newTemplate);

  if (options.nav)
    navComponent = {
      templateId: newTemplate.id,
      title: {
        text: newTemplate.pageName,
        alignment: 1,
        backgroundColor: "#00000000",
        bold: true,
        font: "TimesNewRoman",
        fontSize: 18,
        italics: false,
        textColor: "#000000",
      },
      backgroundImage: null,
    };

  return { newTemplate, navComponent };
};

export default addNewTemplate;

// Just Views
export const textView = (text = "Page Content") => ({
  fontSize: 10,
  text,
  textColor: "#ffffff",
  bold: false,
  italics: false,
  font: null,
  alignment: 1,
  backgroundColor: "#00000000",
  clickAction: null,
});

export const imageView = (url = null) => ({
  url,
  backgroundColor: "#FFFFFF",
  title: "",
  description: "",
  sideTitle: "",
  scaleType: 2,
  isTemp: true,
});

export const defaultTitleTextField = (text = "Input Your Page Title Here") => ({
  fontSize: 40,
  text,
  textColor: "#000000",
  bold: true,
  italics: false,
  font: null,
  alignment: 1,
  backgroundColor: "#00000000",
  // clickAction: null,
});

export const defaultTextField = (
  text = "Place your page content here. Tell you customers a story."
) => ({
  fontSize: 20,
  text,
  textColor: "#000000",
  bold: false,
  italics: false,
  font: null,
  alignment: 1,
  backgroundColor: "#00000000",
  // clickAction: null,
});

// Factory
export const aboutUs = () => ({
  id: newId(),
  type: "aboutUs",
  pageName: "Contact",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
});

export const deals = () => ({
  id: newId(),
  type: "deals",
  pageName: "Deals / Coupons",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  // clickAction: null,
});

export const titleText = () => ({
  id: newId(),
  type: "titleText",
  pageName: "Enter Page Name",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      type: "text",
      componentNumber: 1,
      view: {
        fontSize: 40,
        text: "Input Your Page Title Here",
        textColor: "#000000",
        bold: true,
        italics: false,
        font: null,
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
    {
      type: "text",
      componentNumber: 2,
      view: {
        fontSize: 20,
        text: "Place your page content here. Tell you customers a story.",
        textColor: "#000000",
        bold: false,
        italics: false,
        font: null,
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
  ],
});

export const titleTextCustom = (activeApp) => ({
  id: newId(),
  type: "titleText",
  pageName: "Ordering Instructions",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      type: "text",
      componentNumber: 1,
      view: {
        fontSize: 40,
        text: "How to Order",
        textColor: "#000000",
        bold: true,
        italics: false,
        font: "Playfair Display",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
    {
      type: "text",
      componentNumber: 2,
      view: {
        fontSize: 20,
        text:
          "Welcome to the " +
          activeApp.name +
          " mobile app!\n\nOrdering is simple!\n\t\t\nVisit the “Store” page to see my current items for sale. If you have a promo code, you can enter that code in the “Promo” section at checkout. Add any special requests to the “Additional comments?” section. Any amount of tip to support our small business is much appreciated!\n\nOnce you make a purchase, you will receive an email confirmation with a receipt of your order. \n\nBe sure to create an account and turn on push notifications to stay up to date with our latest items, discounts, and exclusives!\n",
        textColor: "#000000",
        bold: false,
        italics: false,
        font: "Playfair Display",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
  ],
});

export const imageTitleText = () => ({
  id: newId(),
  type: "imageTitleText",
  pageName: "Enter Page Name",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      componentNumber: 1,
      type: "rotatingImageGallery",
      name: "rotatingImageGallery1",
      view: {
        images: [
          {
            url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/upload.png",
            fileName: null,
            backgroundColor: "#FFFFFF",
            description: null,
            clickAction: null,
          },
        ],
      },
    },
    {
      componentNumber: 2,
      type: "text",
      name: "textfield1",
      view: {
        fontSize: 40,
        text: "Input Your Page Title Here",
        textColor: "#000000",
        bold: true,
        italics: false,
        font: null,
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
    {
      type: "text",
      componentNumber: 3,
      view: {
        fontSize: 20,
        text: "Place your page content here. Tell you customers a story.",
        textColor: "#000000",
        bold: false,
        italics: false,
        font: null,
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
  ],
});

export const instructional = () => ({
  id: newId(),
  type: "imageTitleText",
  pageName: "Templates Explained",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      componentNumber: 1,
      type: "rotatingImageGallery",
      name: "rotatingImageGallery1",
      view: {
        images: [
          {
            url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/templates.png",
            fileName: null,
            backgroundColor: "#FFFFFF",
            description: null,
            clickAction: null,
          },
        ],
      },
    },
    {
      componentNumber: 2,
      type: "text",
      name: "textfield1",
      view: {
        fontSize: 40,
        text: "Mobile360 Templates",
        textColor: "#000000",
        bold: true,
        italics: false,
        font: "Playfair Display",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
    {
      type: "text",
      componentNumber: 3,
      view: {
        fontSize: 20,
        text: "\tMobile360 templates are easy to set up and can be managed under the “Current Pages” section on the website admin panel. To edit an existing page in your mobile app, simply click on that page under the “Current Pages” section. Then, click the section on the mobile app preview that you’d like to edit! To add a new page, click the “Add New Page” near the bottom and select the template you’d like to use. Here’s some more information about the templates we have available:\n \n\tTitle & Text - A simple page with two customizable text fields. Examples: Monthly       Specials, Ordering Instructions.\n\n\tImage, Title & Text - A scrolling image set with two customizable text fields. Example: Secret Menu, About Us.\n\n\tImage Gallery - A gallery page with photos and descriptions. Examples: Image Gallery, Menu.\n\n\tStore - This page allows you to create a store for your business. Sell products directly through your mobile app and streamline your ordering process.\n\n\tWebsite - Link any website into your app. Add existing integrations seamlessly. Example: Your existing website, Yelp, Grubhub, OpenTable.\n\n\tPunch Card - Old school punch cards, digitized. Example: Buy 5 coffees, get one free.\n",
        textColor: "#000000",
        bold: false,
        italics: false,
        font: "Anonymous Pro",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
  ],
});

export const imageTitleTextCustom = (activeApp) => ({
  id: newId(),
  type: "imageTitleText",
  pageName: "About Me",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      componentNumber: 1,
      type: "rotatingImageGallery",
      name: "rotatingImageGallery1",
      view: {
        images: [
          {
            url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/support_small_business.jpeg",
            fileName: null,
            backgroundColor: "#FFFFFF",
            description: null,
            clickAction: null,
          },
        ],
      },
    },
    {
      componentNumber: 2,
      type: "text",
      name: "textfield1",
      view: {
        fontSize: 40,
        text: activeApp.name,
        textColor: "#000000",
        bold: true,
        italics: false,
        font: "Playfair Display",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
    {
      type: "text",
      componentNumber: 3,
      view: {
        fontSize: 20,
        text: "(Enter a personalized biography about your and your business. Customers love a personal touch!)",
        textColor: "#000000",
        bold: false,
        italics: false,
        font: "Playfair Display",
        alignment: 1,
        backgroundColor: "#00000000",
        clickAction: null,
      },
    },
  ],
});

export const pictureCatalog = () => ({
  id: newId(),
  type: "pictureCatalog",
  pageName: "Enter Page Name",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      componentNumber: 1,
      type: "pictureCatalog",
      view: {
        sectionDisplayType: "fullPage",
        columns: 3,
        sections: [
          {
            header: {
              alignment: 1,
              backgoundColor: "#ffffff",
              bold: true,
              font: "TimesNewRoman",
              fontSize: 28,
              italics: false,
              text: "Enter Your Section Title",
              textColor: "#000000",
            },
            images: [
              {
                url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/clickToUpload.png",
                backgroundColor: "#FFFFFF",
                title: "",
                description: "",
                sideTitle: "",
                scaleType: 2,
                isTemp: false,
              },
              {
                url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/clickToUpload.png",
                backgroundColor: "#FFFFFF",
                title: "",
                description: "",
                sideTitle: "",
                scaleType: 2,
                isTemp: false,
              },
              {
                url: "https://mobile360-assets.s3.us-east-2.amazonaws.com/clickToUpload.png",
                backgroundColor: "#FFFFFF",
                title: "",
                description: "",
                sideTitle: "",
                scaleType: 2,
                isTemp: false,
              },
            ],
          },
        ],
      },
    },
  ],
});

export const website = () => ({
  id: newId(),
  type: "website",
  pageName: "Website",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
  components: [
    {
      type: "webView",
      componentNumber: 1,
      view: {
        url: "",
      },
    },
  ],
});

export const rewards = () => ({
  id: newId(),
  type: "rewards",
  pageName: "Rewards",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
});

export const punchCard = () => ({
  id: newId(),
  type: "punchCard",
  pageName: "Punch Card",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
});

export const store = () => ({
  id: newId(),
  type: "store",
  pageName: "Store",
  backgroundColor: "#FFFFFF",
  backgroundImage: null,
});

const appCatalog = {
  aboutUs: aboutUs,
  titleText: titleText,
  imageTitleText: imageTitleText,
  deals: deals,
  pictureCatalog: pictureCatalog,
  website: website,
  rewards: rewards,
  punchCard: punchCard,
  store: store,
  titleTextCustom: titleTextCustom,
  imageTitleTextCustom: imageTitleTextCustom,
  instructional: instructional,
};
